export default "/images/4c2f9dd397346ca4d351903141526abb.avif";